const CardOnsiteMessage = () => (
  <>
    <div>
      <h3>Express Cards via PayMongo</h3>
      <p>
        You can now accept card payments directly on your Shopify store
      </p>
    </div>
    <div>
      <h3>Next Steps</h3>
      <p>
        1. Go to the Payments tab on your Shopify settings, and "Activate" Express Cards via PayMongo under the Payment Providers section
      </p>
      <p>
        2. Lastly, on the Payments tab on your Shopify settings, make sure to tick "Automatically at Checkout" under the Payment Capture Method section
      </p>
    </div>
    <div>
      <h3>Reminder</h3>
      <p>
        Express Cards via PayMongo does not accept Hold then Capture (manual capture) transactions. We recommend you deactivate the Credit/Debit via PayMongo app.
      </p>
    </div>
  </>
);

export default CardOnsiteMessage;
